/**
 * 界面展示的版本号。发版时与 `package.json` 的 major.minor 对齐（如 5.0.0 → 展示 5.0）。
 */
export const APP_VERSION = '5.0';

/** 侧栏/顶栏品牌标题，如「贴图虾（5.0）」 */
export const APP_BRAND_TITLE = `贴图虾（${APP_VERSION}）`;
